import styled, { css } from 'styled-components';

import { ErrorText } from '@/shared/components/ErrorMessage';
import { RequiredField } from '@/shared/components/Required';
import type { IMailSubscriptionTheme } from '@/shared/themes/types';

export const InputLabel = styled.label`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    height: 22px;
    margin: 0;
    font-size: ${theme.fontSizes.medium};
    font-weight: ${theme.fontWeight.medium};
    color: ${theme.defaultDarkColor};
  `}
`;

export const InputComponent = styled.input`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    width: 100%;
    height: 40px;
    border: solid 1px ${theme.defaultDarkColor};
    background-color: #ffffff;
    padding-left: 7px;
  `}
`;

export const InputWrapper = styled.div`
  display: grid;
  grid-template-rows: min-content;

  ${ErrorText} {
    margin-top: -6px;
  }
`;
export const PartWithOptInfo = styled.div`
  position: relative;
  display: grid;
  grid-gap: 4px;
  grid-template-rows: min-content;
`;

export const Required = styled(RequiredField).attrs(() => ({
  'aria-hidden': 'true',
}))`
  color: #eb5757;
`;

export const OptInfo = styled.div`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    position: relative;
    ${theme.media.desktop} {
      position: absolute;
    }
  `}
`;
